module.exports = __webpack_public_path__ + "img/colse.3f94ddde.svg";